module.exports = __webpack_public_path__ + "static/media/port_saaid.cf6828c8.jpg";